/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import { useDiscovery } from "../hooks/discovery/useDiscovery";
import DiscoveryHeader from "../components/discoveryy/DiscoveryHeader";
import DiscoveryFilters from "../components/discoveryy/DiscoveryFilters";
import DiscoveryClearFilters from "../components/discoveryy/DiscoveryClearFilters";
import DiscoveryPlayersTable from "../components/discoveryy/DiscoveryPlayersTable";
import DiscoveryPagination from "../components/discoveryy/DiscoveryPagination";

const Discovery = () => {
  const {
    // State
    filters,
    setFilters,
    isFreeAgent,
    sort,
    competitionSearch,
    setCompetitionSearch,
    showCompetitionDropdown,
    setShowCompetitionDropdown,
    currentPage,
    players,
    loading,
    error,
    pagination,
    positions,
    filteredCompetitions,
    filteredCountries,
    filteredDivisionCountries,
    countrySearch,
    setCountrySearch,
    showCountryDropdown,
    setShowCountryDropdown,
    divisionCountrySearch,
    setDivisionCountrySearch,
    showDivisionCountryDropdown,
    setShowDivisionCountryDropdown,

    // Functions
    handleCountrySelect,
    handleDivisionCountrySelect,
    handleCompetitionSelect,
    getSelectedCountryName,
    getSelectedDivisionCountryName,
    getSelectedCompetitionName,
    handleClearAllFilters,
    handleClearFilter,
    hasActiveFilters,
    fetchData,
    paginate,
    handleLevelChange,
    handlePositionChange,
    handleFreeAgentSinceChange,
    handleFreeAgentToggle,
    handleSortChange,
  } = useDiscovery();

  return (
    <div className=" mx-auto pb-6">
      <DiscoveryHeader isFreeAgent={isFreeAgent} handleFreeAgentToggle={handleFreeAgentToggle} />

      <DiscoveryFilters
        filters={filters}
        setFilters={setFilters}
        positions={positions}
        filteredCountries={filteredCountries}
        filteredDivisionCountries={filteredDivisionCountries}
        filteredCompetitions={filteredCompetitions}
        countrySearch={countrySearch}
        setCountrySearch={setCountrySearch}
        showCountryDropdown={showCountryDropdown}
        setShowCountryDropdown={setShowCountryDropdown}
        divisionCountrySearch={divisionCountrySearch}
        setDivisionCountrySearch={setDivisionCountrySearch}
        showDivisionCountryDropdown={showDivisionCountryDropdown}
        setShowDivisionCountryDropdown={setShowDivisionCountryDropdown}
        competitionSearch={competitionSearch}
        setCompetitionSearch={setCompetitionSearch}
        showCompetitionDropdown={showCompetitionDropdown}
        setShowCompetitionDropdown={setShowCompetitionDropdown}
        handleCountrySelect={handleCountrySelect}
        handleDivisionCountrySelect={handleDivisionCountrySelect}
        handleCompetitionSelect={handleCompetitionSelect}
        getSelectedCountryName={getSelectedCountryName}
        getSelectedDivisionCountryName={getSelectedDivisionCountryName}
        getSelectedCompetitionName={getSelectedCompetitionName}
        handleLevelChange={handleLevelChange}
        handlePositionChange={handlePositionChange}
        handleFreeAgentSinceChange={handleFreeAgentSinceChange}
        isFreeAgent={isFreeAgent}
        sort={sort}
        handleSortChange={handleSortChange}
      />

      <DiscoveryClearFilters
        hasActiveFilters={hasActiveFilters}
        filters={filters}
        positions={positions}
        handleClearFilter={handleClearFilter}
        handleClearAllFilters={handleClearAllFilters}
        getSelectedCountryName={getSelectedCountryName}
        getSelectedDivisionCountryName={getSelectedDivisionCountryName}
        getSelectedCompetitionName={getSelectedCompetitionName}
        loading={loading}
      />

      <DiscoveryPlayersTable
        loading={loading}
        error={error}
        players={players}
        isFreeAgent={isFreeAgent}
        fetchData={fetchData}
        currentPage={currentPage}
      />

      <DiscoveryPagination
        pagination={pagination}
        currentPage={currentPage}
        paginate={paginate}
        loading={loading}
      />
    </div>
  );
};

export default Discovery;
